import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { PERMISSION_STORAGE_KEY } from "../../constants/permissions";
import { messages } from "../../constants/commonMessages";
import { extractPermissions } from "../../utils/permissions";
import { getPostLoginRoute } from "../../utils/landingRoute";
import { normalizeUserGroups } from "../../utils/userAccessUtility";

export default function ProcessPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const processData = async () => {
      localStorage.removeItem(PERMISSION_STORAGE_KEY);
      localStorage.removeItem(messages.USER_GROUPS);

      searchParams.forEach((value, key) => {
        const normalizedKey = key.trim().toLowerCase();

        if (normalizedKey === PERMISSION_STORAGE_KEY) {
          localStorage.setItem(
            PERMISSION_STORAGE_KEY,
            JSON.stringify(extractPermissions(value)),
          );
          return;
        }

        if (normalizedKey === "groups" || normalizedKey === "usergroups") {
          localStorage.setItem(
            messages.USER_GROUPS,
            JSON.stringify(normalizeUserGroups(value)),
          );
          return;
        }

        localStorage.setItem(key, value);
      });

      await new Promise((resolve) => setTimeout(resolve, 1500));
      navigate(getPostLoginRoute(), { replace: true });
    };

    processData();
  }, [searchParams, navigate]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      flexDirection="column"
      bgcolor="#f5f5f5"
    >
      <CircularProgress />
      <Typography mt={2} color="textSecondary">
        Processing...
      </Typography>
    </Box>
  );
}
